import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Badge, Card, Modal } from "react-bootstrap";
import { FaUsers, FaFileInvoiceDollar } from "react-icons/fa";

function BasicExample() {
  const [tipoCliData, setTipoCliData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");
        const localita = res.data.AR.localita || [];
        setAllData(localita);

        const aggregation = localita.reduce((acc, item) => {
          const tipo = item.tipo_cliente || "N/D";
          const valore = parseFloat(item.Valore || 0);
          const numDoc = parseInt(item.numero_doc || 0);

          if (!acc[tipo]) {
            acc[tipo] = {
              tipo_cliente: tipo,
              totaleValore: 0,
              totaleDoc: 0,
            };
          }
          acc[tipo].totaleValore += valore;
          acc[tipo].totaleDoc += numDoc;
          return acc;
        }, {});

        const transformedData = Object.values(aggregation);
        setTipoCliData(
          transformedData.sort((a, b) => b.totaleValore - a.totaleValore)
        );
      } catch (err) {
        console.error("Errore caricamento localita:", err);
      }
    };
    fetchData();
  }, []);

  const handleRowClick = (categoria) => {
    setSelectedCategory(categoria);
    setShowModal(true);
  };

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount || 0);

  const modalDetailsRaw = allData.filter(
    (item) => item.tipo_cliente === selectedCategory
  );

  const modalDetailsAggregated = Object.values(
    modalDetailsRaw.reduce((acc, item) => {
      const nome = item.clienti || "N/D";

      if (!acc[nome]) {
        acc[nome] = {
          clienti: nome,
          paese: item.paese || "—",
          Valore: 0,
          numero_doc: 0,
        };
      }

      acc[nome].Valore += parseFloat(item.Valore || 0);
      acc[nome].numero_doc += parseInt(item.numero_doc || 0);

      return acc;
    }, {})
  ).sort((a, b) => b.Valore - a.Valore);

  const totaleValoreModal = modalDetailsAggregated.reduce(
    (sum, item) => sum + item.Valore,
    0
  );
  const totaleDocModal = modalDetailsAggregated.reduce(
    (sum, item) => sum + item.numero_doc,
    0
  );
  const totaleClientiModal = modalDetailsAggregated.length;

  return (
    <>
      <Card
        className="card ombra bg-dark card-home border-0 p-2 p-md-3 am-data-card am-types-card"
        style={{ borderRadius: "15px", width: "100%", maxWidth: "100%" }}
      >
        <div
          className="no-scrollbar am-table-scroll"
          style={{
                        width: "100%",
          }}
        >
          <Table
            hover
            variant="dark"
            className="mb-0 custom-table"
            style={{
              fontSize: "0.75rem",
              width: "100%",
              margin: 0,
              borderCollapse: "separate",
              tableLayout: "fixed", /* Forza le colonne a stare nel 100% dello schermo */
            }}
          >
            <thead className="sticky-top" style={{ zIndex: 10 }}>
              <tr
                className="text-light bg-dark small"
                style={{ borderBottom: "2px solid #333" }}
              >
                <th
                  style={{ width: "45%" }}
                  className="ps-2 ps-md-3 py-3 border-0 text-light bg-dark text-truncate"
                >
                  TIPO CLIENTE
                </th>
                <th
                  style={{ width: "35%", color: "rgba(241,111,36,1)" }}
                  className="py-3 border-0 text-end cursor-pointer bg-dark text-truncate"
                >
                  VALORE TOTALE
                </th>
                <th
                  style={{ width: "20%" }}
                  className="py-3 pe-2 pe-md-3 border-0 text-end cursor-pointer text-light bg-dark text-truncate"
                >
                  DOC
                </th>
              </tr>
            </thead>
            <tbody>
              {tipoCliData.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => handleRowClick(item.tipo_cliente)}
                  style={{ cursor: "pointer" }}
                  className="align-middle"
                >
                  <td className="fw-bold ps-2 ps-md-3 text-light bg-dark text-truncate">
                    {item.tipo_cliente}
                  </td>
                  <td
                    className="text-end fw-bold bg-dark text-truncate"
                    style={{ color: "rgba(241,111,36,1)" }}
                  >
                    {formatToEuro(item.totaleValore)}
                  </td>
                  <td className="text-end text-light bg-dark pe-2 pe-md-3">
                    <Badge bg="secondary" pill style={{ fontSize: "0.7rem" }}>
                      {item.totaleDoc}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* MODAL DETTAGLIO CLIENTI PER CATEGORIA */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="am-type-modal"
        dialogClassName="am-type-modal-dialog"
        contentClassName="am-type-modal-content"
        backdropClassName="am-type-modal-backdrop"
      >
        <Modal.Header closeButton className="am-type-modal-header border-0">
          <Modal.Title className="w-100">
            <div className="am-type-modal-title">
              <div className="am-type-modal-icon">
                <FaUsers size={20} />
              </div>

              <div className="am-type-modal-heading">
                <small>CATEGORIA CLIENTI</small>

                <strong>
                  {selectedCategory || "N/D"}
                </strong>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="am-type-modal-body">
          {/* KPI */}
          <div className="am-type-kpi-grid">
            <div className="am-type-kpi-card">
              <span>CLIENTI</span>

              <strong>
                <FaUsers />
                {totaleClientiModal}
              </strong>
            </div>

            <div className="am-type-kpi-card">
              <span>DOCUMENTI</span>

              <strong>
                <FaFileInvoiceDollar />
                {totaleDocModal}
              </strong>
            </div>

            <div className="am-type-kpi-card is-highlight">
              <span>VALORE TOTALE</span>

              <strong>
                {formatToEuro(totaleValoreModal)}
              </strong>
            </div>
          </div>

          {/* TABELLA */}
          <div className="am-type-detail-panel">
            <div className="am-type-detail-header">
              <div>
                <small>DETTAGLIO CLIENTI</small>
                <strong>Clienti appartenenti alla categoria</strong>
              </div>

              <span>
                {totaleClientiModal} clienti
              </span>
            </div>

            <div className="am-type-table-scroll">
              <Table
                hover
                className="mb-0 am-type-detail-table"
                style={{
                  tableLayout: "fixed",
                  width: "100%",
                  fontSize: "0.75rem",
                }}
              >
                <thead>
                  <tr>
                    <th
                      className="ps-2 ps-md-3"
                      style={{ width: "40%" }}
                    >
                      RAGIONE SOCIALE
                    </th>

                    <th
                      className="d-none d-sm-table-cell"
                      style={{ width: "20%" }}
                    >
                      LOCALITÀ
                    </th>

                    <th
                      className="text-end"
                      style={{ width: "25%" }}
                    >
                      VALORE
                    </th>

                    <th
                      className="text-center pe-2 pe-md-3"
                      style={{ width: "15%" }}
                    >
                      DOC
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {modalDetailsAggregated.map((client, i) => (
                    <tr key={i} className="align-middle">
                      <td className="ps-2 ps-md-3 fw-bold text-uppercase text-truncate">
                        {client.clienti}
                      </td>

                      <td className="text-truncate d-none d-sm-table-cell">
                        {client.paese}
                      </td>

                      <td className="text-end fw-bold text-truncate am-type-value">
                        {formatToEuro(client.Valore)}
                      </td>

                      <td className="text-center pe-2 pe-md-3">
                        <Badge pill className="am-type-doc-badge">
                          {client.numero_doc}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <style>{`
        /* =====================================================
           TABELLA PRINCIPALE
           ===================================================== */

        .custom-table tbody tr:hover td {
          background-color: rgba(255,255,255,0.035) !important;
        }

        .ombra {
          box-shadow: 0 8px 30px rgba(0,0,0,0.15);
        }

        .no-scrollbar {
          scrollbar-width: none !important;
          -ms-overflow-style: none !important;
        }

        .no-scrollbar::-webkit-scrollbar {
          display: none !important;
          width: 0 !important;
          height: 0 !important;
        }

        .sticky-top {
          top: -1px;
          background: #212529 !important;
        }

        /* =====================================================
           BACKDROP
           ===================================================== */

        .am-type-modal-backdrop.show {
          opacity: 0.88 !important;
          background: #07090d !important;

          backdrop-filter: none !important;
          -webkit-backdrop-filter: none !important;
        }

        /* =====================================================
           DIALOG / CONTENT
           ===================================================== */

        .am-type-modal-dialog {
          width: min(920px, calc(100vw - 32px)) !important;
          max-width: 920px !important;
          margin: 16px auto !important;
        }

        .am-type-modal-content {
          position: relative;

          max-height: calc(100dvh - 32px);
          overflow: hidden;

          color: #f5f6f8 !important;

          background:
            radial-gradient(
              circle at 0% 0%,
              rgba(241,111,36,0.18),
              transparent 34%
            ),
            radial-gradient(
              circle at 100% 8%,
              rgba(255,255,255,0.04),
              transparent 28%
            ),
            linear-gradient(
              145deg,
              rgba(39,42,49,0.94),
              rgba(20,22,27,0.97)
            ) !important;

          border: 1px solid rgba(255,255,255,0.11) !important;
          border-radius: 24px !important;

          box-shadow:
            0 32px 80px rgba(0,0,0,0.58),
            inset 0 1px 0 rgba(255,255,255,0.09) !important;

          backdrop-filter: blur(8px) saturate(115%);
          -webkit-backdrop-filter: blur(8px) saturate(115%);
        }

        .am-type-modal-content::before {
          content: "";

          position: absolute;
          top: 0;
          left: 24px;

          width: 42%;
          height: 1px;

          background: linear-gradient(
            90deg,
            #f16f24,
            transparent
          );

          pointer-events: none;
          z-index: 3;
        }

        /* =====================================================
           HEADER
           ===================================================== */

        .am-type-modal-header {
          padding: 20px 22px 13px !important;

          background: transparent !important;

          border-bottom:
            1px solid rgba(255,255,255,0.06) !important;
        }

        .am-type-modal-title {
          display: flex;
          align-items: center;

          min-width: 0;
          gap: 12px;
        }

        .am-type-modal-icon {
          flex: 0 0 44px;

          width: 44px;
          height: 44px;

          display: flex;
          align-items: center;
          justify-content: center;

          color: #ff8847;

          background:
            linear-gradient(
              145deg,
              rgba(241,111,36,0.22),
              rgba(241,111,36,0.08)
            );

          border:
            1px solid rgba(241,111,36,0.30);

          border-radius: 14px;

          box-shadow:
            inset 0 1px 0 rgba(255,255,255,0.055);
        }

        .am-type-modal-heading {
          display: flex;
          flex-direction: column;

          min-width: 0;
        }

        .am-type-modal-heading small {
          margin-bottom: 3px;

          color: rgba(255,255,255,0.34);

          font-size: 0.55rem;
          font-weight: 850;
          letter-spacing: 0.09em;
        }

        .am-type-modal-heading strong {
          overflow: hidden;

          color: #fff;

          font-size: 1.12rem;
          font-weight: 850;
          line-height: 1.15;

          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .am-type-modal-content .btn-close {
          width: 34px;
          height: 34px;

          margin: 0 !important;
          padding: 0 !important;

          border-radius: 50%;

          background-color: rgba(255,255,255,0.075);
          background-size: 11px;

          filter: invert(1) grayscale(1);

          opacity: 0.75;
        }

        .am-type-modal-content .btn-close:hover {
          opacity: 1;

          background-color: rgba(241,111,36,0.17);
        }

        /* =====================================================
           BODY
           ===================================================== */

        .am-type-modal-body {
          padding: 10px 22px 22px !important;

          overflow-y: auto;

          background: transparent !important;

          scrollbar-width: none !important;
          -ms-overflow-style: none !important;
        }

        .am-type-modal-body::-webkit-scrollbar {
          display: none !important;
          width: 0 !important;
          height: 0 !important;
        }

        /* =====================================================
           KPI
           ===================================================== */

        .am-type-kpi-grid {
          display: grid;

          grid-template-columns:
            repeat(3, minmax(0, 1fr));

          gap: 10px;

          margin-bottom: 12px;
        }

        .am-type-kpi-card {
          padding: 12px 14px;

          background:
            linear-gradient(
              145deg,
              rgba(255,255,255,0.055),
              rgba(255,255,255,0.025)
            );

          border:
            1px solid rgba(255,255,255,0.075);

          border-radius: 14px;

          box-shadow:
            inset 0 1px 0 rgba(255,255,255,0.035);
        }

        .am-type-kpi-card.is-highlight {
          background:
            linear-gradient(
              145deg,
              rgba(241,111,36,0.15),
              rgba(241,111,36,0.055)
            );

          border-color:
            rgba(241,111,36,0.20);
        }

        .am-type-kpi-card span {
          display: block;

          margin-bottom: 5px;

          color: rgba(255,255,255,0.35);

          font-size: 0.55rem;
          font-weight: 850;
          letter-spacing: 0.075em;
        }

        .am-type-kpi-card strong {
          display: flex;
          align-items: center;

          gap: 7px;

          color: #fff;

          font-size: 0.98rem;
          font-weight: 850;
        }

        .am-type-kpi-card strong svg {
          color: #f16f24;
          font-size: 0.82rem;
        }

        .am-type-kpi-card.is-highlight strong {
          color: #ff8847;
        }

        /* =====================================================
           DETAIL PANEL
           ===================================================== */

        .am-type-detail-panel {
          overflow: hidden;

          background: rgba(8,10,13,0.24);

          border:
            1px solid rgba(255,255,255,0.075);

          border-radius: 16px;
        }

        .am-type-detail-header {
          display: flex;

          align-items: center;
          justify-content: space-between;

          gap: 12px;

          padding: 11px 13px;

          border-bottom:
            1px solid rgba(255,255,255,0.06);
        }

        .am-type-detail-header > div {
          display: flex;
          flex-direction: column;
        }

        .am-type-detail-header small {
          color: rgba(255,255,255,0.34);

          font-size: 0.53rem;
          font-weight: 850;
          letter-spacing: 0.08em;
        }

        .am-type-detail-header strong {
          margin-top: 2px;

          color: rgba(255,255,255,0.86);

          font-size: 0.76rem;
        }

        .am-type-detail-header > span {
          color: rgba(255,255,255,0.40);

          font-size: 0.63rem;
          font-weight: 700;
        }

        /* =====================================================
           TABELLA SCROLLABILE - BARRA NASCOSTA
           ===================================================== */

        .am-type-table-scroll {
          max-height: 390px;

          overflow-y: auto;
          overflow-x: auto;

          scrollbar-width: none !important;
          -ms-overflow-style: none !important;

          overscroll-behavior: contain;
        }

        .am-type-table-scroll::-webkit-scrollbar {
          display: none !important;
          width: 0 !important;
          height: 0 !important;
        }

        .am-type-detail-table {
          width: 100%;

          margin: 0 !important;

          color: rgba(255,255,255,0.70) !important;
          background: transparent !important;
        }

        .am-type-detail-table
        > :not(caption)
        > *
        > * {
          background: transparent !important;
          box-shadow: none !important;
        }

        .am-type-detail-table thead th {
          position: sticky;
          top: 0;

          z-index: 3;

          padding: 9px 13px !important;

          color: rgba(255,255,255,0.38) !important;
          background: #191c21 !important;

          border: 0 !important;

          border-bottom:
            1px solid rgba(255,255,255,0.065) !important;

          font-size: 0.57rem;
          font-weight: 850;
          letter-spacing: 0.075em;

          white-space: nowrap;
        }

        .am-type-detail-table tbody td {
          padding: 10px 13px !important;

          color: rgba(255,255,255,0.72) !important;

          border: 0 !important;

          border-bottom:
            1px solid rgba(255,255,255,0.045) !important;
        }

        .am-type-detail-table tbody tr:hover td {
          background:
            rgba(255,255,255,0.035) !important;
        }

        .am-type-detail-table
        tbody
        td:first-child {
          color: rgba(255,255,255,0.88) !important;
        }

        .am-type-value {
          color: #ff8847 !important;
        }

        .am-type-doc-badge {
          min-width: 32px;

          padding:
            4px
            7px !important;

          color: rgba(255,255,255,0.72) !important;

          background:
            rgba(255,255,255,0.075) !important;

          border:
            1px solid rgba(255,255,255,0.09) !important;

          font-size: 0.58rem !important;
          font-weight: 800 !important;
        }

        /* =====================================================
           MOBILE
           ===================================================== */

        @media screen and (max-width: 767px) {
          .am-type-modal-dialog {
            width:
              calc(100vw - 14px) !important;

            max-width: none !important;

            margin:
              7px auto !important;
          }

          .am-type-modal-content {
            max-height:
              calc(100dvh - 14px);

            border-radius:
              19px !important;
          }

          .am-type-modal-header {
            padding:
              16px
              15px
              10px !important;
          }

          .am-type-modal-body {
            padding:
              8px
              15px
              15px !important;
          }

          .am-type-modal-icon {
            flex-basis: 38px;

            width: 38px;
            height: 38px;

            border-radius: 12px;
          }

          .am-type-modal-heading strong {
            font-size: 0.98rem;
          }

          .am-type-kpi-grid {
            grid-template-columns:
              repeat(3, minmax(0, 1fr));

            gap: 6px;
          }

          .am-type-kpi-card {
            padding: 9px 8px;
          }

          .am-type-kpi-card span {
            font-size: 0.48rem;
          }

          .am-type-kpi-card strong {
            gap: 4px;

            font-size: 0.75rem;
          }

          .am-type-table-scroll {
            max-height: 48vh;
          }

          .am-type-detail-table
          thead th,
          .am-type-detail-table
          tbody td {
            padding:
              9px
              9px !important;
          }
        }
      `}</style>
    </>
  );
}

export default BasicExample;
